export const SERVICE_CODES = {
  diesel: 27
} as const;
